import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export const addEditPurchasesModalSlice = createSlice({
  name: 'addEditPurchasesModal',
  initialState: {
    showModal: false,
    title: 'New Purchases',
    editMode: false,
    servicedetails: [],
    old_servicedetails: [],
    purchases_expense: [],
    old_purchases_expense: [],
    purchases_type: '',
    reg_date: moment().format('YYYY-MM-DD'),
    poMode: false,
    note: '',
    purchasesheader_doc: '',
    purchasesheader_doc_prev: ''
  },
  reducers: {
    togglePurchasesModal: (state, action) => {
      state.showModal = !state.showModal;
      state.title =
        action.payload && action.payload.title
          ? action.payload.title
          : 'New Purchases';
      state.reg_date =
        action.payload && action.payload.reg_date
          ? action.payload.reg_date
          : moment().format('YYYY-MM-DD');
      state.editMode =
        action.payload && action.payload.editMode
          ? action.payload.editMode
          : false;
      state.servicedetails =
        action.payload && action.payload.servicedetails
          ? action.payload.servicedetails
          : [];
      state.old_servicedetails =
        action.payload && action.payload.old_servicedetails
          ? action.payload.old_servicedetails
          : [];
      state.purchases_expense =
        action.payload && action.payload.purchases_expense
          ? action.payload.purchases_expense
          : [];
      state.old_purchases_expense =
        action.payload && action.payload.old_purchases_expense
          ? action.payload.old_purchases_expense
          : [];
      state.tax_exempt =
        action.payload && action.payload.tax_exempt
          ? action.payload.tax_exempt
          : '';
      state.note =
        action.payload && action.payload.note ? action.payload.note : '';
      state.selectedSuppliersData =
        action.payload && action.payload.selectedSuppliersData
          ? action.payload.selectedSuppliersData
          : null;
      state.selectedPurchasesTypeData =
        action.payload && action.payload.selectedPurchasesTypeData
          ? action.payload.selectedPurchasesTypeData
          : null;
      state.poMode =
        action.payload && action.payload.poMode ? action.payload.poMode : false;
      state.purchasesheader_doc =
        action.payload && action.payload.purchasesheader_doc ? action.payload.purchasesheader_doc : '';
      state.purchasesheader_doc_prev =
        action.payload && action.payload.purchasesheader_doc_prev ? action.payload.purchasesheader_doc_prev : '';
    },
  },
});

export const { togglePurchasesModal } = addEditPurchasesModalSlice.actions;
export default addEditPurchasesModalSlice.reducer;
